import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UrlService {

  constructor() { }

  // End-point to generate result for user question

  public generateSql = 'generate_sql';

  public userLogin = 'V2/user/login';

  public faqs='user_recommendations';

  public getConversations='conversations';

  public deleteAllConversations='user_conversations';

  public starredQuestions='starred-questions';

  public graph='graph';

  public resetPasscode='user/reset_passcode';

  public feedback='/feedback';

  public trainingData='training_data';

  public trainingDataVersion(trainingId: number): string {
    return `training_data/${trainingId}/versions`;
  }
  public getAllMessages(id: string): string {
    return `conversations/${id}/messages`;
  }

  public trainedQuestions='trained-questions'


}
